import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Navigate, Outlet, RouterProvider, createHashRouter, useNavigate } from "react-router-dom";
import { AppProvider, useAppState } from "./AppContext";
import { ExceptionPage } from "@/pages/ExceptionPage";
import { GamePage } from "@/pages/GamePage";
import { GuidePage } from "@/pages/GuidePage";
import { HomePage } from "@/pages/HomePage";
import { ImagePage } from "@/pages/ImagePage";
import { InfoPage } from "@/pages/InfoPage";
import { SetupPage } from "@/pages/SetupPage";
const ExceptionRedirect = () => {
    const navigate = useNavigate();
    const { exception } = useAppState();
    useEffect(() => {
        if (exception) {
            navigate("/exception");
        }
    }, [exception, navigate]);
    return null;
};
const AppShell = () => (_jsxs(AppProvider, { children: [_jsx(ExceptionRedirect, {}), _jsx(Outlet, {})] }));
const router = createHashRouter([
    {
        path: "/",
        element: _jsx(AppShell, {}),
        children: [
            { index: true, element: _jsx(Navigate, { to: "/home", replace: true }) },
            { path: "home", element: _jsx(HomePage, {}) },
            { path: "input", element: _jsx(SetupPage, {}) },
            { path: "game", element: _jsx(GamePage, {}) },
            { path: "info", element: _jsx(InfoPage, {}) },
            { path: "guide", element: _jsx(GuidePage, {}) },
            { path: "img/:cardId", element: _jsx(ImagePage, {}) },
            { path: "exception", element: _jsx(ExceptionPage, {}) },
            { path: "*", element: _jsx(Navigate, { to: "/home", replace: true }) }
        ]
    }
]);
export const App = () => _jsx(RouterProvider, { router: router });
